import { useEffect, useState } from "react";
import { FiX } from "react-icons/fi";
import { BtnDefault } from "../../../../../../components/buttons/BtnDefault";
import { InputDefault } from "../../../../../../components/forms/InputDefault";
import { PppoeUserService } from "../../../../../../services/PppoeUserService";

export const PppoeOntConfigUpdate = ({
  data,
  open,
  setOpen,
  refreshData,
}) => {
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    username: "",
    password: "",
    wifi_name: "",
    wifi_password: "",
  });

  const [error, setError] = useState({
    username: "",
    password: "",
    wifi_name: "",
    wifi_password: "",
  });

  /* ── Isi form dari data yang sudah ada ── */
  useEffect(() => {
    if (data && open) {
      setFormData({
        username: data?.ont_configuration?.username || "",
        password: data?.ont_configuration?.password || "",
        wifi_name: data?.ont_configuration?.wifi_name || "",
        wifi_password: data?.ont_configuration?.wifi_password || "",
      });
      setError({
        username: "",
        password: "",
        wifi_name: "",
        wifi_password: "",
      });
    }
  }, [data, open]);

  const handleChange = (e) => {
    const { id, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [id]: value,
    }));

    setError((prev) => ({
      ...prev,
      [id]: "",
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      await PppoeUserService.ontConfigUpdate({
        data: formData,
        id: data.id,
      });

      refreshData?.();
      setOpen(false);
    } catch (err) {
      if (err.response?.data?.errors) {
        // mapping error dari backend (format: { secret_username: ["..."] })
        const serverErrors = err.response.data.errors;
        setError((prev) => ({
          username: serverErrors.username?.[0] || "",
          password: serverErrors.password?.[0] || "",
          wifi_name: serverErrors.wifi_name?.[0] || "",
          wifi_password: serverErrors.wifi_password?.[0] || "",
        }));
      }
    } finally {
      setLoading(false);
    }
  };

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-[999] flex items-center justify-center p-4 bg-black/50 backdrop-blur-sm">
      <div className="bg-slate-800 w-full max-w-lg rounded-2xl shadow-2xl overflow-visible">

        {/* Header */}
        <div className="flex items-center justify-between px-6 py-4 border-b border-white/10">
          <h3 className="text-lg font-bold text-white">
            Update Konfigurasi Ont
          </h3>
          <button
            onClick={() => setOpen(false)}
            className="p-2 hover:bg-white/10 rounded-full transition-colors"
          >
            <FiX size={20} className="text-white" />
          </button>
        </div>

        {/* Form */}
        <form onSubmit={handleSubmit} className="p-6 space-y-4">

          {/* id wajib sama persis dengan key di formData */}
          <InputDefault
            id="username"
            label="Username"
            type="text"
            placeholder="Masukkan username"
            value={formData.username}
            onChange={handleChange}
            error={error.username}
          />

          <InputDefault
            id="password"
            label="Password"
            type="text"
            placeholder="Masukkan password"
            value={formData.password}
            onChange={handleChange}
            error={error.password}
          />

          <InputDefault
            id="wifi_name"
            label="Nama Wifi"
            type="text"
            placeholder="Masukkan nama wifi"
            value={formData.wifi_name}
            onChange={handleChange}
            error={error.wifi_name}
          />

          <InputDefault
            id="wifi_password"
            label="Password Wifi"
            type="text"
            placeholder="Masukkan password wifi"
            value={formData.wifi_password}
            onChange={handleChange}
            error={error.wifi_password}
          />

          {/* Footer */}
          <div className="flex gap-3 pt-4 border-t border-white/10">
            <button
              type="button"
              disabled={loading}
              onClick={() => setOpen(false)}
              className="flex-1 px-4 py-2.5 border border-white text-white rounded-xl font-semibold hover:bg-white/10 disabled:opacity-50 transition-colors"
            >
              Batal
            </button>

            <BtnDefault
              type="submit"
              disabled={loading}
              className="flex-1 justify-center py-2.5"
            >
              {loading ? "Sedang Menyimpan..." : "Simpan"}
            </BtnDefault>
          </div>
        </form>
      </div>
    </div>
  );
};